import { Component, OnInit, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef, MatDialog } from '@angular/material';
import { bottomSheet } from '../../Model/Shared/bottomSheet.interface';
import { Router } from '@angular/router';
import { ModalInformationComponent } from 'app/pages/Seguridad/menus/modal-information/modal-information.component';
import { MenusFacadeService } from '../../pages/Seguridad/menus/menus-facade.service';

@Component({
  selector: 'app-bottomsheet',
  templateUrl: './bottomsheet.component.html',
  styleUrls: ['./bottomsheet.component.css']
})
export class BottomsheetComponent implements OnInit {

  constructor(private _bottomSheetRef: MatBottomSheetRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: bottomSheet,
    public router: Router, public dialog: MatDialog,
    private menuFacade:MenusFacadeService) {
      console.log(data);
    }

  ngOnInit(): void {
  }

  openLink(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }

  navegar(data){
    if(data.tipo == 1){
      this.router.navigateByUrl(data.ruta);
    }
    if (data.tipo == 2) {
      this.openDialog(data);
    }
    if(data.tipo == 3){
        this.menuFacade.subMenuConstruir(data?.idMenuPadre);
    }
  }

  openDialog(data) {
    const dialogRef = this.dialog.open(ModalInformationComponent, {
      width: '80vw',
      maxWidth: '100vw',
      data: data
    });
  }

}
